// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-8943d514]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.terms-and-conditions[data-v-8943d514]{font-size:13.2px}div[data-v-8943d514]{padding:20px}.colour[data-v-8943d514]{color:#f0f}#patient-terms-and-conditions[data-v-8943d514],#provider-terms-and-conditions[data-v-8943d514]{font-size:14px!important}", ""]);
// Exports
module.exports = exports;
